// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".biikap0 {\n  border-radius: 8px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);\n  background: white;\n  overflow: hidden;\n}\n.biikap1 {\n  margin: 10px;\n}\n.biikap2 {\n  border-radius: 8px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);\n  background: white;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
